// Get Creator Details Public
export const GET_CREATOR_DETAILS_PUBLIC_REQUEST = 'GET_CREATOR_DETAILS_PUBLIC_REQUEST';
export const GET_CREATOR_DETAILS_PUBLIC_DONE = 'GET_CREATOR_DETAILS_PUBLIC_DONE';
export const GET_CREATOR_DETAILS_PUBLIC_FAILED = 'GET_CREATOR_DETAILS_PUBLIC_FAILED';

// Get Creator Details Custom
export const GET_CREATOR_DETAILS_CUSTOM_REQUEST = 'GET_CREATOR_DETAILS_CUSTOM_REQUEST';
export const GET_CREATOR_DETAILS_CUSTOM_DONE = 'GET_CREATOR_DETAILS_CUSTOM_DONE';
export const GET_CREATOR_DETAILS_CUSTOM_FAILED = 'GET_CREATOR_DETAILS_CUSTOM_FAILED';

// Get Creator Details Sendbird
export const GET_CREATOR_DETAILS_SENDBIRD_REQUEST = 'GET_CREATOR_DETAILS_SENDBIRD_REQUEST';
export const GET_CREATOR_DETAILS_SENDBIRD_DONE = 'GET_CREATOR_DETAILS_SENDBIRD_DONE';
export const GET_CREATOR_DETAILS_SENDBIRD_FAILED = 'GET_CREATOR_DETAILS_SENDBIRD_FAILED';

export const GET_CREATOR_DETAILS_RESET = 'GET_CREATOR_DETAILS_RESET';
